
export function passwordGenerator(length = 16) {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=';
  const array = new Uint32Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, x => charset[x % charset.length]).join('');
}